export const multiselectOperators = [
    { text: 'Is one of', operator: 'in' },
    { text: 'Is not one of', operator: 'notin' },
];

export const isMultiselectOperator = (operator: string | Function) =>
    multiselectOperators.some(o => o.operator === operator);
